import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EColorPalette } from '@shared/enums/color-palette.enum';
import { EIcon } from '@shared/enums/icon.enum';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  @Input() type: 'warning' | 'info' | 'error' = 'warning';
  @Input() icon?: EIcon;
  @Input() iconColor?: EColorPalette;

  EIcon = EIcon;
  EColorPalette = EColorPalette;
}
